import React, { useCallback } from "react";
import { useStoreActions, useStoreState } from "easy-peasy";
import PropTypes from "prop-types";
import { isMobile } from "../../utils/ResponsiveUtils";

const MuteButton = ({ containerId }) => {
  const { buildUrl } = document.getElementById(
    "irobot-embedded-interactive-experience"
  ).dataset;
  const isMuted = useStoreState((state) => state.experience.isMuted);
  const setMuted = useStoreActions((actions) => actions.experience.setMuted);

  const toggleMute = useCallback(() => {
    setMuted(!isMuted);
  }, [setMuted, isMuted]);

  const onClickMuteBtn = useCallback(() => {
    toggleMute();
  }, [toggleMute]);

  return (
    <>
      <button className="mute-btn" type="button" onClick={onClickMuteBtn}>
        <img
          src={
            isMuted
              ? `${buildUrl}/images/player-controls/sound-off.png`
              : `${buildUrl}/images/player-controls/sound-on.png`
          }
          alt={isMuted ? "Unmute" : "Mute"}
        />
        <span className="visually-hidden">{isMuted ? "Unmute" : "Mute"}</span>
      </button>
      <style jsx="true">
        {`
          #${containerId} .mute-btn {
            box-shadow: none !important;
            border: 0 !important;
            border-radius: 50% !important;
            background-color: transparent !important;
            background-image: none !important;
            padding: 0 !important;
            margin: 0 !important;
            cursor: pointer !important;
            display: flex !important;
            justify-content: center !important;
            align-items: center !important;

            ${isMobile()
              ? `
              width: 44px !important;
              height: 44px !important;
            `
              : `
              width: 72px !important;
              height: 72px !important;
            `}
          }
          #${containerId} .mute-btn img {
            display: block !important;
            height: 50% !important;
            width: auto !important;
            cursor: pointer !important;
          }
        `}
      </style>
    </>
  );
};

MuteButton.propTypes = {
  containerId: PropTypes.string.isRequired,
  mobileResponsiveUtil: PropTypes.shape({
    getHeightValue: PropTypes.func,
    getWidthValue: PropTypes.func,
    getFontSize: PropTypes.func,
  }),
};

MuteButton.defaultProps = {
  mobileResponsiveUtil: {
    getHeightValue: () => {},
    getWidthValue: () => {},
    getFontSize: () => {},
  },
};

export default MuteButton;
